import { useState } from "react";
import { ArrowUpRight, PieChart, ShieldCheck, Sprout, Trophy } from "lucide-react";
import { Link } from "react-router-dom";

const CATEGORIES = [
  { name: "Equity Funds", icon: Trophy, risk: "High", horizon: "7+ years", returns: "12–15% p.a. (long-term avg)", note: "Own a slice of India's growth story. Best for long-term goals like retirement and children's education.", ideal: "Wealth creation" },
  { name: "Hybrid Funds", icon: PieChart, risk: "Moderate", horizon: "3–5 years", returns: "9–11% p.a. (long-term avg)", note: "A measured blend of equity and debt — growth with a cushion for investors who prefer steadier rides.", ideal: "Balanced growth" },
  { name: "Debt Funds", icon: ShieldCheck, risk: "Low", horizon: "1–3 years", returns: "6–8% p.a. (long-term avg)", note: "Stability first. Better-than-FD potential for money you may need sooner, with high liquidity.", ideal: "Capital protection" },
  { name: "ELSS (Tax Saver)", icon: Sprout, risk: "High", horizon: "3+ years", returns: "Tax saving u/s 80C + growth", note: "Save up to ₹46,800 in tax under Section 80C while your money compounds in equities.", ideal: "Tax planning" },
];

export default function MutualFundBanner() {
  const [active, setActive] = useState(0);
  const fund = CATEGORIES[active];
  const Icon = fund.icon;
  const riskWidth = { Low: 28, Moderate: 55, High: 85 }[fund.risk];
  return (
    <section className="mf-banner" data-testid="mutual-fund-banner">
      <div className="mf-banner-inner section-wrap">
        <div className="mf-banner-copy">
          <p className="eyebrow">MUTUAL FUND INVESTMENTS</p>
          <h2>One habit.<br /><em>Every goal covered.</em></h2>
          <p>Start a SIP from just ₹500 a month. We help you pick the right fund category for each goal, review it quarterly, and keep your plan on track — in plain English.</p>
          <Link className="button button-gold" to="/contact" data-testid="mf-banner-cta">Start your SIP <ArrowUpRight size={16} /></Link>
        </div>
        <div className="mf-explorer">
          <div className="mf-tabs" data-testid="mf-category-tabs">
            {CATEGORIES.map((cat, index) => <button key={cat.name} className={active === index ? "selected" : ""} onClick={() => setActive(index)} data-testid={`mf-tab-${index}`}>{cat.name}</button>)}
          </div>
          <div className="mf-card" key={fund.name} data-testid="mf-category-card">
            <div className="mf-card-head"><span className="mf-icon"><Icon size={22} /></span><div><h3>{fund.name}</h3><span className="mf-ideal">Best for: {fund.ideal}</span></div></div>
            <p>{fund.note}</p>
            <div className="mf-risk-row"><span>Risk level · {fund.risk}</span><div className="pulse-track mf-track"><div className="pulse-fill mf-fill" style={{ width: `${riskWidth}%` }} /></div></div>
            <div className="mf-facts"><div><span>IDEAL HORIZON</span><strong>{fund.horizon}</strong></div><div><span>POTENTIAL</span><strong>{fund.returns}</strong></div></div>
          </div>
        </div>
      </div>
    </section>
  );
}
